// function PlanningAndActionsPage() {
//   return <div></div>;
// }

// export default PlanningAndActionsPage;

import { Col, message } from "antd";
import { Icons } from "../assets/icons";
import PageHeader from "../components/ui/PageHeader";
import { ICON_SIZE } from "../repository/data.default";
import FooterQuoteCard from "../components/ui/FooterQuoteCard";
import SatageSubHeader from "../components/ui/SatageSubHeader";
import SectionTwo from "../components/PlanningActionsSections/SectionTwo";
import ViewReportCard from "../components/ui/ViewReportCard";

const footerText = (
  <p>
    The organization should take into account human factors in relation to
    psychosocial hazards in all parts of an OH&S management system. Human
    factors represent the abilities and limitations of people, and therefore are
    relevant to the success or otherwise of risk assessment, risk controls and
    the design, implementation and effectiveness of work tasks or processes.
    Awareness of human factors when designing and re-designing work can lead to
    more positive outcomes in relation to work-related ill health and injury. A
    range of methods can be used to analyze human factors relevant to particular
    work tasks, including observation, consultation, task analysis techniques
    and specialized audits
  </p>
);

const stepsList = (
  <>
    <li>a. Analyze findings and evaluate results</li>
    <li>b. Identify needs & prioritize risks</li>
    <li>c. Allocate budget & resources</li>
    <li>d. Develop key metrics</li>
    <li>e. Create and Allocate Programs</li>
    <li>f. Create and send monthly surveys</li>
  </>
);
const overviewText = (
  <p>
    Welcome to the Planning and Actions Step, a structured process designed to
    translate organizational well-being goals into actionable initiatives. This
    step focuses on analyzing data, prioritizing risks, allocating resources,
    setting measurable objectives, and implementing programs to improve
    workplace well-being. It ensures a data-driven and goal-oriented approach to
    enhance employee satisfaction, reduce risks, and foster a healthier work
    environment.
  </p>
);

const viewReportCardText = `The Risks & Findings Report step involves reviewing collected data from assessments, and feedback to identify key organizational challenges and opportunities. The goal is to dive deeper into existing risks, quantify their impact, and prioritize them for action.`;
function PlanningActionsPage() {
  return (
    <Col className="relative flex flex-auto flex-col overflow-hidden overflow-y-auto">
      {/* Header */}
      <PageHeader
        stage={3}
        title={"PLANNING & ACTIONS"}
        icon={
          <Icons.PlanningActionsIcon width={ICON_SIZE} height={ICON_SIZE} />
        }
      />
      {/* Sub Header  */}
      <SatageSubHeader overviewText={overviewText} stepsList={stepsList} />

      {/* View Report */}
      <ViewReportCard
        title="RISKS & FINDINGS"
        text={viewReportCardText}
        btnName="view report"
        btnAction={() => message.info("This report is not yet available.")}
      />

      {/* Steps Section */}
      <SectionTwo />

      {/* Footer */}
      <FooterQuoteCard
        icon={<Icons.PlanningAndActionsIcon width={350} height={350} />}
        text={footerText}
      />
    </Col>
  );
}

export default PlanningActionsPage;
